<template>
  <template v-if="showFooter">
    <div v-if="!isTxt">
      <el-select
        :modelValue="modelValue"
        multiple
        collapse-tags
        style="width: 100%"
        @remove-tag="removeTag"
        @click="visible = true"
      />
    </div>
    <div v-else>{{ modelValue }}</div>
  </template>
  <RxkDialog
    title="城市多选"
    width="950px"
    v-model="visible"
    alignCenter
    class="city_dialog"
    @sure="sure"
    @close="handleClose"
    :footer="false"
    :showFooter="showFooter"
  >
    <div class="city_content">
      <div class="area-main">
        <div
          v-for="(item, index) in cityList"
          :key="item.provinceId"
          :class="{ active: activeIndex === index }"
        >
          <div class="province-box" @click.stop="activeIndex = index">
            <el-checkbox
              v-model="item.checked"
              :disabled="item.disabled ?? disabled"
              :indeterminate="indeterminate(item)"
              @change="changeAll($event, index)"
            />
            <span>
              {{ item.name }}
              <span class="num">{{ `${checkNum(index)}/${item.children.length}` }}</span>
            </span>
          </div>
          <div
            class="sub-city"
            v-if="activeIndex === index"
            :style="`transform: translateX(-${(index % 4) * 25}%)`"
          >
            <el-checkbox
              v-model="child.checked"
              v-for="child in item.children"
              :key="child.cityId"
              :disabled="disabled"
              @change="changeCity(child, index)"
            >
              {{ child.name }}
            </el-checkbox>
          </div>
        </div>
      </div>
    </div>
  </RxkDialog>
</template>

<script setup>
import { defineProps, defineEmits, ref, onMounted, onBeforeUnmount, defineExpose } from 'vue'
import { RxkDialog } from '@/components/common/RxkDialog'
import { recursion } from '@/utils'
import { getCityList } from '@/apis/erp/productApi'
import { events } from '@/eventBus'

defineOptions({
  inheritAttrs: false
})
const props = defineProps({
  isTxt: {
    type: Boolean,
    default: false
  },
  modelValue: {
    type: [String, Array],
    default: ''
  },
  // 外部获取完整已选中的城市信息
  getIntactCityInfo: {
    type: Function,
    default: () => {}
  },
  showFooter: {
    type: Boolean,
    default: true
  },
  disabled: {
    type: Boolean,
    default: false
  }
})
const cityList = ref([])
const emits = defineEmits(['update:modelValue', 'intactCityInfo'])
const visible = ref(false)
const activeIndex = ref(0)
const indeterminate = item => {
  let children = item.children
  if (item.checked) {
    return false
  } else {
    let flag = false
    if (children.every(item => item.checked)) {
      flag = false
    } else {
      flag = children.some(item => item.checked)
    }
    return flag
  }
}
const checkNum = index => {
  let children = cityList.value[index].children
  let temp = children.filter(item => item.checked)
  return temp.length
}
const changeAll = (val, index) => {
  if (cityList.value[index].name === '全部') {
    recursion(
      cityList.value,
      item => {
        item.checked = val
      },
      'children'
    )
  } else {
    cityList.value[index].children.forEach(item => {
      item.checked = val
    })
  }
}
const changeCity = (child, index) => {
  if (child.name === '全部') {
    recursion(
      cityList.value,
      item => {
        item.checked = child.checked
      },
      'children'
    )
  } else {
    let temp = cityList.value[index].children.filter(item => item.checked)
    let len = temp.length
    let childLen = cityList.value[index].children.length
    cityList.value[index].checked = len === childLen
  }
}
const initData = () => {
  recursion(
    cityList.value,
    item => {
      if (props.modelValue.includes(item.name)) {
        item.checked = true
      } else {
        item.checked = false
      }
    },
    'children'
  )
  // 全选省回显
  cityList.value.forEach((province, index) => {
    let temp = province.children.filter(item => item.checked)
    let len = temp.length
    let childLen = province.children.length
    const checked = len === childLen
    province.checked = checked
    if (props.disabled) {
      province.disabled = checked ? false : true
      checked && (activeIndex.value = index)
    }
  })
}
const handleClose = () => {
  visible.value = false
}
onMounted(async () => {
  if (!props.isTxt) {
    const res = await getCityList()

    cityList.value = res
    initData()
  }

  events.on('getIntactCityData', () => sure())
})

onBeforeUnmount(() => {
  events.off('getIntactCityData')
})

const removeTag = v => {
  emits(
    'update:modelValue',
    props.modelValue.filter(item => item !== v)
  )
}
const sure = () => {
  console.log(
    '%c [lalalalala  ]-183',
    'font-size:13px; background:pink; color:#bf2c9f;',
    cityList.value,
    props.isTxt
  )
  let cityArr = []
  // 完整的城市信息
  let intactSelectedArr = []
  recursion(
    cityList.value,
    item => {
      if (item.cityId && item.checked) {
        cityArr.push(item.name)
        intactSelectedArr.push(item)
      }
    },
    'children'
  )
  visible.value = false
  emits('update:modelValue', cityArr)

  // 外部获取完整已选中的城市信息---方式一
  emits('intactCityInfo', { intactSelectedArr, allCityList: cityList.value })

  // 外部获取完整已选中的城市信息---方式二（例如，通过"Render"间接引入，Render本身无事件穿透）
  props.getIntactCityInfo?.({
    intactSelectedArr,
    allCityList: cityList.value
  })
}
watch(
  () => props.modelValue,
  () => {
    initData()
  }
)
defineExpose({
  handleOpen() {
    visible.value = true
  }
})
</script>

<style lang="scss" scoped>
.value_box {
  height: 30px;
}
.city_content {
  color: #666666;
  font-size: 14px;
  padding: 16px 24px;
  .area-main {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    height: 600px;
    overflow-y: auto;
    .num {
      color: $primary-color;
    }
    > div {
      width: 25%;
      margin-top: 8px;
      margin-bottom: 0;
      .province-box {
        display: flex;
        cursor: pointer;
        align-items: center;
        :deep(.el-checkbox) {
          margin-right: 24px;
        }
      }
      .sub-city {
        margin-top: 12px;
        width: 400%;
        padding: 20px 8px 4px 24px;
        background-color: #eee;
        display: flex;
        flex-wrap: wrap;
        > label {
          min-width: calc(20% - 16px);
          max-width: 50%;
          margin-bottom: 1px;
        }
      }
      &.active {
        :deep(& > .t-checkbox > .t-checkbox__label) {
          color: $primary-color;
        }
      }
    }
  }
}
</style>
